import { aQ as R, b4 as u, al as d } from "./value-extraction-C_fDiBaZ.js";
import { l as X } from "./product-CdujHKtW.js";
var z = /* @__PURE__ */ ((e) => (e[e.SELLER = 1] = "SELLER", e[e.BUYER = 2] = "BUYER", e))(z || {});
const oe = [
  1,
  2
  /* BUYER */
], P = "broker", Y = "seller", E = "buyer", S = "seller_proxy", _ = "buyer_proxy", Q = "office_head", Z = "supervisor", O = "settlement_broker", y = "builder", L = "entrepreneur", b = "surveyor", A = "renter", f = "rentee", T = "tenant", N = "landlord", p = "previous_owner", h = "new_owner", I = "legal_owner", le = "power_of_attorney", q = "proxy", J = "spouse", C = "employment", G = "shareholder", w = "manager", U = "boardChair", x = "boardMember", B = "signatureEligible", D = "authorizedSignatory", v = "realLicensee", M = "accountant", $ = "companyContact", F = "other", H = "ceo", j = "mortagee", V = "customerAdvisor", W = "treasurer", k = "auditor", K = "appropriationRepresentativeSeller", ie = [
  P,
  Y,
  E,
  S,
  _,
  q,
  Q,
  Z,
  O,
  y,
  L,
  b,
  A,
  f,
  T,
  N,
  p,
  h,
  I,
  J,
  C,
  G,
  w,
  U,
  x,
  B,
  D,
  v,
  M,
  $,
  F,
  H,
  j,
  V,
  W,
  k,
  K
], ee = (e) => {
  switch (e) {
    case E:
    case _:
    case f:
    case T:
    case p:
      return 2;
  }
  return 1;
}, ue = (e) => ({
  2: [
    E,
    _,
    f,
    T,
    h
  ],
  1: [
    P,
    Y,
    S,
    O,
    y,
    L,
    b,
    A,
    N,
    p,
    I,
    C,
    G,
    w,
    U,
    x,
    B,
    D,
    v,
    M,
    $,
    F,
    H,
    j,
    V,
    W,
    k,
    K
  ]
})[e] || [], ce = (e, a) => ({
  sources: e,
  targets: a
}), se = (e) => {
  let a = String(e).split(":");
  return {
    uid: a[0],
    type: a[1]
  };
}, te = (e) => {
  let a = String(e).split(":"), r = a[0], s = a[1], n = [], t = s.indexOf("(");
  if (t > -1) {
    let l = s.indexOf(")");
    t < l && (n = s.substring(t + 1, l).split(",").map((o) => o.trim()).filter((o) => !!o), s = s.substring(0, t));
  }
  return {
    uid: r,
    action: s,
    arguments: n
  };
}, de = (e) => {
  let a = [], r = {};
  if (!Array.isArray(e) || !e.length)
    return r;
  for (let s of e)
    a.push({
      ...s,
      sources: s.sources.map(se),
      targets: s.targets.map(te)
    });
  for (let s of a) {
    let n = {};
    for (let t of s.targets)
      t.uid in n || (n[t.uid] = {}), t.action in n[t.uid] || (n[t.uid][t.action] = []), n[t.uid][t.action] = n[t.uid][t.action].concat(s.sources);
    for (let t of s.sources) {
      t.uid in r || (r[t.uid] = {}), t.type in r[t.uid] || (r[t.uid][t.type] = []);
      let l = {};
      for (let i of s.targets)
        if (n[i.uid][i.action])
          for (let o of n[i.uid][i.action])
            o.uid != t.uid && (o.uid in l || (l[o.uid] = /* @__PURE__ */ new Set()), l[o.uid].add(o.type));
      r[t.uid][t.type] = r[t.uid][t.type].concat({
        targets: s.targets,
        other_sources: l
      });
    }
  }
  return r;
}, ae = (e) => e.arguments.length ? `${e.uid}:${e.action}(${e.arguments.join(", ")})` : `${e.uid}:${e.action}`, Ee = (e) => {
  let a = [], r = {};
  return R(e, (s, n) => {
    R(s, (t, l) => {
      for (let i of t) {
        const o = i.targets.map(ae);
        if (!o.length)
          continue;
        const c = {
          sources: [n + ":" + l],
          targets: o
        }, g = c.sources.join("+") + "->" + c.targets.join("+");
        (r[g] ?? !1) || (r[g] = !0, a.push(c));
      }
    });
  }), a;
}, m = (e, a, r) => {
  let s = String(e).split(":");
  return s[0] == a && (s[0] = r), s.join(":");
}, _e = (e, a, r) => {
  for (let s of e) {
    let n = 0;
    for (let t of s.sources)
      s.sources[n] = m(t, a, r), n++;
    n = 0;
    for (let t of s.targets)
      s.targets[n] = m(t, a, r), n++;
  }
}, fe = (e, a) => ({
  id: u("person-"),
  external_id: u("person-external-"),
  contact_id: 0,
  name: null,
  firstname: null,
  role: e,
  type: a,
  birthdate: {
    iso: null,
    timestamp: null
  },
  contact: {
    phone: {
      international: null,
      national: null
    },
    email: null
  },
  address: {
    address: null,
    postcode: null,
    city: null,
    copied: !1
  },
  billing_address: {
    address: null,
    postcode: null,
    city: null,
    use_custom_address: null,
    use_estate_address: null,
    use_person_address: null
  },
  on_behalf: {
    name: null,
    images: [],
    myself: null,
    power_of_attorney_received: null
  },
  index: 0,
  selected: !1,
  validated: !1,
  content_agreed: !1,
  absent: !1,
  signature: null,
  signature_type: null
}), Te = (e) => (e.id || (e.id = u("person-")), e.external_id || (e.external_id = u("person-external-")), e.role || (e.role = ee(e.type || "")), typeof e.validated != "boolean" && (e.validated = !1), e.billing_address || (e.billing_address = {
  address: null,
  postcode: null,
  city: null,
  use_person_address: null,
  use_estate_address: null,
  use_custom_address: null
}), e.billing_address.use_person_address = null, e.billing_address.use_estate_address = null, e.billing_address.use_custom_address = null, e), pe = (e, a) => {
  if (e.role < a.role)
    return -1;
  if (e.role > a.role)
    return 1;
  let r = String(e.type).localeCompare(String(a.type));
  if (r != 0)
    return r;
  let s = String(e.name).toLocaleLowerCase() + String(e.firstname).toLocaleLowerCase(), n = String(a.name).toLocaleLowerCase() + String(a.firstname).toLocaleLowerCase();
  return s.localeCompare(n);
}, ge = (e) => {
  if (!e || e == "@")
    return null;
  let a = String(e).split(":"), r = a[0];
  switch (r) {
    case "bankid":
      let s = a[1].split(";");
      return d({
        type: r,
        name: s[0],
        person_number: s[1],
        timestamp: Number(s[2])
      });
    case "data":
      return d({
        type: "image",
        datauri: e
      });
    default:
      return d({
        type: r
      });
  }
}, Re = (e, a, r, s) => `<span class="signing-on-behalf-description" role="presentation">${X(e, s, "", {
  "on_behalf.name": `<span class="on-behalf-name" role="presentation">${r}</span>`,
  "person.name": `<span class="on-behalf-person-name" role="presentation">${a}</span>`
})}</span>`;
export {
  ee as $,
  p as A,
  h as B,
  I as C,
  le as D,
  q as E,
  J as F,
  C as G,
  G as H,
  w as I,
  U as J,
  x as K,
  B as L,
  D as M,
  v as N,
  M as O,
  z as P,
  $ as Q,
  oe as R,
  F as S,
  P as T,
  H as U,
  j as V,
  V as W,
  W as X,
  k as Y,
  K as Z,
  ie as _,
  ce as a,
  ue as a0,
  se as b,
  fe as c,
  te as d,
  de as e,
  Re as f,
  ae as g,
  Ee as h,
  Y as i,
  E as j,
  S as k,
  _ as l,
  Q as m,
  Te as n,
  Z as o,
  ge as p,
  O as q,
  _e as r,
  pe as s,
  y as t,
  L as u,
  b as v,
  A as w,
  f as x,
  T as y,
  N as z
};
//# sourceMappingURL=person-D_kW40Oo.js.map
